// extracted by mini-css-extract-plugin
export default {"container":"On-z","bubbleNav":"Pn-z","graphic":"Qn-z","contact":"Rn-z"};